// Library Imports
import { motion } from "framer-motion";
// Functions, Helpers, Utils, and Hooks
import joinClassNames from "../../utils/joinClassNames";
// CSS
import "./dependents/css/card.scss";

type CardProps = {
  children: React.ReactNode;
  additionalClassNames?: string;
  hoverEffect?: boolean;
};

const Card: React.FC<CardProps> = ({
  children,
  additionalClassNames,
  hoverEffect = false,
}) => {
  return (
    <motion.div
      className={joinClassNames(
        "card padding-top-20 padding-bottom-20 padding-left-40 padding-right-40",
        additionalClassNames
      )}
      initial={{ opacity: 0, y: 20 }} // start state
      animate={{ opacity: 1, y: 0 }} // end state
      transition={{ duration: 1, ease: "easeOut" }}
      whileHover={{ scale: hoverEffect === true ? 1.05 : 1.0 }} // slight grow on hover
      whileTap={{ scale: hoverEffect === true ? 0.97 : 1.0 }} // shrink on click/tap
    >
      {children}
    </motion.div>
  );
};

export default Card;
